import { Chip } from "$components/chip";
import { useIntl } from "react-intl";
import type { ExternalReference } from "./build-line-item";
import type { PaymentStatus } from "./payment-status";
import { usePaymentStatus } from "./use-payment-status";

const STATUS_DISPLAY = {
  awaiting: {
    color: "warning",
    label: {
      id: "billing.paymentStatus.awaiting",
      defaultMessage: "Awaiting payment",
    },
  },
  paid: {
    color: "success",
    label: { id: "billing.paymentStatus.paid", defaultMessage: "Paid" },
  },
  exempt: {
    color: "disabled",
    label: { id: "billing.paymentStatus.exempt", defaultMessage: "Exempt" },
  },
} as const;

export const PaymentStatusBadge = ({
  status,
}: {
  status: PaymentStatus | null;
}) => {
  const { formatMessage } = useIntl();
  if (!status) return null;
  const { color, label } = STATUS_DISPLAY[status];
  return <Chip label={formatMessage(label)} color={color} />;
};

/**
 * Self-contained badge for a service-point order: resolves the order's payment
 * status from the patient's invoices and renders nothing outside PRE_SERVICE.
 */
export const OrderPaymentBadge = ({
  patientId,
  externalReference,
}: {
  patientId: string;
  externalReference: ExternalReference | null;
}) => {
  const status = usePaymentStatus({ patientId, externalReference });
  return <PaymentStatusBadge status={status} />;
};
